import { WsSelectObj } from 'wisestep-base';

interface IOption {
  label: string;
  url: string;
}

export interface UploadLogoDTO {
  organizationEntityId: WsSelectObj[];
  logoUrl: string;
}

export const workspaceSettingsIndexOptions: IOption[] = [
  { label: 'Workspace Logo', url: '/invoice/settings/payment_type' },
];
